/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBookmarkFavorite = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 2v20l-8-6-8 6V2zm-2 1.985H6v13.701l6-4.103 6 4.103zM12 5l1.176 2.382 2.628.382-1.902 1.854.45 2.618L12 11l-2.351 1.236.449-2.618-1.902-1.854 2.628-.382z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBookmarkFavorite as BookmarkFavorite };
